var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49998 5.6251C6.87704 5.6251 8.09382 5.95018 9.08232 6.37518C9.9949 6.77512 10.5694 7.67492 10.5694 8.65015V10H0.430542V8.6585C0.430542 7.67492 1.00535 6.77512 1.91765 6.38352C2.90615 5.95018 4.12292 5.6251 5.49998 5.6251ZM5.49998 2.62532e-06C5.83298 -0.00047366 6.1628 0.0638603 6.47054 0.189318C6.77828 0.314776 7.0579 0.498891 7.29338 0.731116C7.52886 0.963341 7.71556 1.23911 7.84279 1.54262C7.97003 1.84614 8.03529 2.17143 8.03485 2.49986C8.03533 2.82832 7.97009 3.15364 7.84288 3.45719C7.71566 3.76073 7.52896 4.03654 7.29348 4.26879C7.058 4.50104 6.77837 4.68518 6.47061 4.81066C6.16284 4.93613 5.833 5.00048 5.49998 5C5.16699 5.00044 4.83718 4.93607 4.52945 4.81058C4.22172 4.68509 3.94212 4.50094 3.70667 4.26869C3.47122 4.03644 3.28455 3.76065 3.15735 3.45712C3.03015 3.1536 2.96492 2.8283 2.9654 2.49986C2.96496 2.17145 3.03021 1.84618 3.15743 1.54269C3.28465 1.23919 3.47133 0.963436 3.70677 0.731215C3.94222 0.498994 4.2218 0.314872 4.52952 0.189398C4.83723 0.0639236 5.16701 -0.000437014 5.49998 2.62532e-06Z",
    fill: "#056EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconBlue);
export default __webpack_public_path__ + "static/media/user_icon_blue.ba910db32d4638c5f2573ce43629f6ed.svg";
export { ForwardRef as ReactComponent };